import React from "react";
import "./styles.css";

// Строка из нескольких полей формы в две (и больше) колонки — вместо одной длинной
// вертикальной ленты InputWrapper'ов. Оборачивает несколько <InputWrapper>: они сами
// становятся колонками (flex 1 1 240px, оборачиваются на узких экранах).
export default function InputRow({ className = '', children }) {
    return <div className={`input__row ${className}`}>{children}</div>;
}
